(function () {
  function initializePacificaCollection() {
    const page = document.querySelector('.pacifica-collection');
    if (!page) return;
    if (window.__pacificaCollectionController) window.__pacificaCollectionController.abort();

    const controller = new AbortController();
    const signal = controller.signal;
    window.__pacificaCollectionController = controller;

    const filterForm = page.querySelector('#CollectionFiltersForm');
    const filterPanel = page.querySelector('#filterPanel');
    const backdrop = page.querySelector('#mobileBackdrop');
    const sortSelect = page.querySelector('[data-sort-select]');

    function closeFilters() {
      if (!filterPanel) return;
      filterPanel.classList.remove('is-open');
      filterPanel.setAttribute('aria-hidden', 'true');
      page.querySelectorAll('.pc-filter-trigger').forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      });
      if (backdrop) backdrop.hidden = true;
    }

    function openFilters(target) {
      if (!filterPanel) return;
      filterPanel.classList.add('is-open');
      filterPanel.setAttribute('aria-hidden', 'false');
      page.querySelectorAll('.pc-filter-trigger').forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', 'true');
      });
      if (backdrop && window.innerWidth < 768) backdrop.hidden = false;
      const group = target === 'availability' ? page.querySelector('#availabilityGroup') : null;
      if (group) group.scrollIntoView({ block: 'nearest' });
    }

    page.querySelectorAll('.pc-filter-trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        if (filterPanel && filterPanel.classList.contains('is-open')) closeFilters();
        else openFilters(trigger.dataset.panel || 'all');
      }, { signal: signal });
    });
    if (backdrop) backdrop.addEventListener('click', closeFilters, { signal: signal });
    window.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeFilters();
    }, { signal: signal });

    if (sortSelect && filterForm) {
      sortSelect.addEventListener('change', function () { filterForm.requestSubmit(); }, { signal: signal });
    }

    const priceRange = page.querySelector('[data-price-range]');
    const minPrice = page.querySelector('[data-min-price]');
    const maxPrice = page.querySelector('[data-max-price]');
    const priceOutput = page.querySelector('[data-price-output]');
    function updatePriceDisplay() {
      if (!priceRange || !maxPrice) return;
      maxPrice.value = priceRange.value;
      if (priceOutput) {
        const minimum = Number(minPrice && minPrice.value ? minPrice.value : 0);
        const maximum = Number(maxPrice.value || priceRange.max);
        priceOutput.textContent = '$' + minimum.toLocaleString() + ' to $' + maximum.toLocaleString();
      }
    }
    if (priceRange) priceRange.addEventListener('input', updatePriceDisplay, { signal: signal });
    if (minPrice) minPrice.addEventListener('input', function () {
      if (priceOutput) updatePriceDisplay();
    }, { signal: signal });
    if (maxPrice) maxPrice.addEventListener('input', function () {
      if (priceRange) priceRange.value = maxPrice.value || priceRange.max;
      if (priceOutput) updatePriceDisplay();
    }, { signal: signal });

    page.querySelectorAll('.pc-wishlist').forEach(function (button) {
      button.addEventListener('click', function () {
        const selected = button.getAttribute('aria-pressed') === 'true';
        button.setAttribute('aria-pressed', String(!selected));
        button.textContent = selected ? '♡' : '♥';
      }, { signal: signal });
    });

  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializePacificaCollection);
  else initializePacificaCollection();
  document.addEventListener('shopify:section:load', initializePacificaCollection);
})();
